import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { Page } from 'seagull';
import LoadingIndicator from './LoadingIndicator';
export default function PageLoadingState(props) {
    return /*#__PURE__*/ _jsx(Page, _object_spread_props(_object_spread({}, props), {
        children: /*#__PURE__*/ _jsx(LoadingIndicator, {})
    }));
}
